var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import classNames from 'classnames';
import { Numberbox } from '@comall-backend-builder/components-basis';

var NumberMode = function () {
  function NumberMode() {}
  /**
   * 获取无数据状态展示组件
   */


  NumberMode.prototype.getNotAvailableDisplayComponent = function (displayInfo) {
    var className = displayInfo.className,
        style = displayInfo.style;
    return React.createElement("span", {
      className: classNames('type-not-available', className),
      style: style
    }, "NA");
  };
  /**
   * 获取有数据状态展示组件
   */


  NumberMode.prototype.getAvailableDisplayComponent = function (value, displayInfo) {
    var className = displayInfo.className,
        style = displayInfo.style;
    displayInfo = __assign(__assign({}, displayInfo), {
      className: classNames('type-number', className)
    });
    return React.createElement("span", {
      className: className,
      style: style
    }, value);
  };
  /**
   * 获取展示组件
   */


  NumberMode.prototype.getDisplayComponent = function (value, displayInfo) {
    if (value === undefined || value === null) {
      return this.getNotAvailableDisplayComponent(displayInfo);
    } else {
      return this.getAvailableDisplayComponent(value, displayInfo);
    }
  };
  /**
   * 获取输入组件
   */


  NumberMode.prototype.getControlComponent = function (controlInfo) {
    return React.createElement(Numberbox, __assign({}, controlInfo));
  };

  return NumberMode;
}();

export { NumberMode };